import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router";
import { BsArrowRightShort } from "react-icons/bs";
import { HashLoader } from "react-spinners";

import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { useDispatch, useSelector } from "react-redux";
import { enableModal, updateModal } from "../../store/mainReducer";
import { dateForHumans } from "../../utils/dateForHumans";

const columns = [
  { id: "image", align: "center", label: "Image", minWidth: 50 },
  { id: "name", align: "center", label: "Name", minWidth: 150 },
  {
    id: "start_date",
    label: "Start Date",
    minWidth: 100,
    align: "center",
  },
  {
    id: "validate",
    label: "Validate Tickets",
    minWidth: 100,
    align: "center",
  },
  {
    id: "statistics",
    label: "See Statistics",
    minWidth: 100,
    align: "center",
  },
  {
    id: "manage",
    label: "Manage and Update",
    minWidth: 100,
    align: "center",
  },
];

export default function EventsTable({ userData, loading }) {
  let { userEvents } = useSelector((state) => state.main);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToInsights = (id) => {
    navigate(`/event-statistics?id=${id}`);
  };

  const goToManage = (id) => {
    navigate(`/event-management?id=${id}`);
  };

  const handleCheck = (id) => {
    window.localStorage.setItem("eventToCheckQR", JSON.stringify(id));

    dispatch(enableModal(true));
    dispatch(updateModal("checkQRView"));
    return;
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <HashLoader color={COLORS.mainAccent} />
        </div>
      ) : (
        <Paper sx={{ width: "100%" }}>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        top: 0,
                        minWidth: column.minWidth,
                        fontFamily: "AuthenticSans90",
                        color: COLORS.grey,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {userEvents?.map((event, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      {columns.map((column) => {
                        const value = event[column.id];

                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            sx={{
                              padding: "10px",
                              fontFamily: "AuthenticSans90",
                              fontWeight: "bold",
                            }}
                          >
                            {column.id === "image" ? (
                              <img
                                src={userData.logo}
                                style={{ width: "30px" }}
                              />
                            ) : null}
                            {column.id === "validate" && (
                              <MainButton
                                text={"Validate"}
                                width={"120px"}
                                color={"transparent"}
                                textColor={COLORS.black}
                                borderColor={"transparent"}
                                shadowColor={COLORS.mainAccent}
                                textHoverColor={COLORS.mainAccent}
                                onClickAction={() => handleCheck(event._id)}
                                iconPosition={"right"}
                              >
                                <BsArrowRightShort
                                  color={COLORS.black}
                                  size={30}
                                />
                              </MainButton>
                            )}
                            {column.id === "statistics" && (
                              <MainButton
                                text={"Statistics"}
                                width={"130px"}
                                color={"transparent"}
                                textColor={COLORS.black}
                                borderColor={"transparent"}
                                shadowColor={COLORS.mainAccent}
                                textHoverColor={COLORS.mainAccent}
                                onClickAction={() => goToInsights(event._id)}
                                iconPosition={"right"}
                              >
                                <BsArrowRightShort
                                  color={COLORS.black}
                                  size={30}
                                />
                              </MainButton>
                            )}
                            {column.id === "manage" && (
                              <MainButton
                                text={"Manage "}
                                width={"122px"}
                                color={"transparent"}
                                textColor={COLORS.black}
                                borderColor={"transparent"}
                                shadowColor={COLORS.mainAccent}
                                textHoverColor={COLORS.mainAccent}
                                onClickAction={() => goToManage(event._id)}
                                iconPosition={"right"}
                              >
                                <BsArrowRightShort
                                  color={COLORS.black}
                                  size={30}
                                />
                              </MainButton>
                            )}
                            {column.id === "start_date" &&
                              dateForHumans(value, false, true)}
                            {column.id === "name" && value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ height: "50px" }} />
        </Paper>
      )}
    </>
  );
}
